window.GeometryAlgolia = window.GeometryAlgolia || {};

window.GeometryAlgolia.getImage = function (item, size) {
  if (!item) return null;

  if (window.algoliaShopify && window.algoliaShopify.helpers && window.algoliaShopify.helpers.renderImage) {
    try {
      var renderedImage = window.algoliaShopify.helpers.renderImage(item, size);
      if (renderedImage && renderedImage.src) return renderedImage;
    } catch (_error) {}
  }

  if (typeof item.image === "string" && item.image) {
    return {
      src: item.image,
      srcset: "",
      sizes: "",
    };
  }

  if (item.image && typeof item.image === "object") {
    var src = item.image.src || item.image.url || item.image.original || item.image.medium || item.image.large;
    if (src) {
      return {
        src: src,
        srcset: item.image.srcset || "",
        sizes: "",
      };
    }
  }

  return null;
};

window.GeometryAlgolia.getProductUrl = function (item) {
  if (!item) return "#";

  if (
    window.algoliaShopify &&
    window.algoliaShopify.helpers &&
    typeof window.algoliaShopify.helpers.instantsearchLink === "function"
  ) {
    return window.algoliaShopify.helpers.instantsearchLink(item);
  }

  if (item.handle) {
    var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : "/";
    return root + "products/" + item.handle;
  }

  return item.url || "#";
};

window.GeometryAlgolia.displayPriceNoDecimals = function (item, distinct) {
  if (!window.algoliaShopify || !window.algoliaShopify.helpers) return "";

  var price = window.algoliaShopify.helpers.displayPrice(item, distinct);
  if (price === null || typeof price === "undefined") return "";

  return String(price).replace(/\.\d{2}(?=\D|$)/g, "");
};

window.GeometryAlgolia.categoryLinks = [
  { label: "Kitchen", path: "pages/kitchen", image: "Geometry9.11.25_0091.jpg" },
  { label: "Table", path: "pages/table", image: "Geometry6.11.25_0400_1_result.webp" },
  { label: "Bath", path: "pages/bath", image: "Geometry9.2.25_0041_result.webp" },
  { label: "Blankets", path: "pages/blankets", image: "0039__0000s_0006_MB-MF-theo-2.jpg" },
  { label: "Active", path: "pages/active", image: "Copy_of_GrantPuckett_GeometryFitness_00325.jpg" },
  { label: "Beach", path: "pages/beach", image: "Beach-Game-Edit-111.jpg" },
  { label: "Pet", path: "pages/pet", image: "GEO_WelcomeSeries-6_03-Alt1.png" },
  { label: "Gift Cards", path: "pages/gift-cards", image: "Geometry-SpringEaster-GrantPuckett-0397-Retouch.jpg" },
];

window.GeometryAlgolia.getThemeRoute = function (path) {
  var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : "/";
  return root + path.replace(/^\//, "");
};

window.GeometryAlgolia.getShopFileImage = function (filename, width) {
  if (!filename) return "";
  return "/cdn/shop/files/" + encodeURIComponent(filename) + "?width=" + (width || 160);
};

window.GeometryAlgolia.getInfiniteHitsWidget = function () {
  if (window.instantsearch && window.instantsearch.widgets && window.instantsearch.widgets.infiniteHits) {
    return window.instantsearch.widgets.infiniteHits;
  }

  if (
    window.algoliaShopify &&
    window.algoliaShopify.externals &&
    window.algoliaShopify.externals.widgets &&
    window.algoliaShopify.externals.widgets.infiniteHits
  ) {
    return window.algoliaShopify.externals.widgets.infiniteHits;
  }

  return null;
};

window.GeometryAlgolia.trackInstantSearchProduct = function (item) {
  if (
    window.algoliaShopify &&
    window.algoliaShopify.helpers &&
    typeof window.algoliaShopify.helpers.handleItemClick === "function"
  ) {
    window.algoliaShopify.helpers.handleItemClick(item);
  }
};

window.GeometryAlgolia.autocompleteProductsStep = 12;
window.GeometryAlgolia.autocompleteProductsLimit = window.GeometryAlgolia.autocompleteProductsStep;
window.GeometryAlgolia.autocompleteProductsCount = null;

window.GeometryAlgolia.resetAutocompleteProductsLimit = function () {
  window.GeometryAlgolia.autocompleteProductsLimit = window.GeometryAlgolia.autocompleteProductsStep;
  window.GeometryAlgolia.autocompleteProductsCount = null;
  window.GeometryAlgolia.autocompleteLoadingMore = false;
};

window.GeometryAlgolia.getAutocompletePanelScroller = function () {
  var panel = document.querySelector(".aa-Panel");
  if (!panel) return null;

  var candidates = [
    panel.querySelector(".aa-Panel--scrollable"),
    panel.querySelector(".aa-PanelLayout"),
    panel,
  ];

  for (var index = 0; index < candidates.length; index += 1) {
    var candidate = candidates[index];
    if (candidate && candidate.scrollHeight > candidate.clientHeight) return candidate;
  }

  return panel;
};

window.GeometryAlgolia.restoreAutocompleteScrollPosition = function () {
  var scrollTop = window.GeometryAlgolia.autocompleteScrollTop;
  if (typeof scrollTop !== "number") return;

  var scroller = window.GeometryAlgolia.getAutocompletePanelScroller();
  if (scroller) scroller.scrollTop = scrollTop;
};

window.GeometryAlgolia.findAutocompleteController = function () {
  var roots = [];

  if (window.algoliaShopify) {
    roots.push(window.algoliaShopify);
    if (window.algoliaShopify.config) roots.push(window.algoliaShopify.config);
  }

  var seen = [];

  var findController = function (value, depth) {
    if (!value || typeof value !== "object" || depth > 3 || seen.indexOf(value) !== -1) return null;
    seen.push(value);

    if (typeof value.refresh === "function" && typeof value.update === "function") return value;

    var keys = Object.keys(value);
    for (var index = 0; index < keys.length; index += 1) {
      var result = findController(value[keys[index]], depth + 1);
      if (result) return result;
    }

    return null;
  };

  for (var index = 0; index < roots.length; index += 1) {
    var controller = findController(roots[index], 0);
    if (controller) return controller;
  }

  return null;
};

window.GeometryAlgolia.refreshAutocompleteProducts = function () {
  var controller = window.GeometryAlgolia.autocompleteController || window.GeometryAlgolia.findAutocompleteController();
  var refresh = window.GeometryAlgolia.autocompleteRefresh || (controller && controller.refresh);

  if (controller) {
    window.GeometryAlgolia.autocompleteController = controller;
  }

  if (typeof refresh === "function") {
    refresh.call(controller || window.algoliaShopify);
    window.setTimeout(window.GeometryAlgolia.restoreAutocompleteScrollPosition, 0);
    window.setTimeout(window.GeometryAlgolia.restoreAutocompleteScrollPosition, 120);
    return;
  }

  var input = document.querySelector(".aa-Input");
  if (input) {
    input.dispatchEvent(new Event("input", { bubbles: true }));
  }
};

window.GeometryAlgolia.loadMoreAutocompleteProductsIfNeeded = function () {
  var scroller = window.GeometryAlgolia.getAutocompletePanelScroller();
  if (!scroller || window.GeometryAlgolia.autocompleteLoadingMore) return;

  var remainingScroll = scroller.scrollHeight - scroller.scrollTop - scroller.clientHeight;
  if (remainingScroll > 700) return;

  var currentLimit = window.GeometryAlgolia.autocompleteProductsLimit;
  var totalProducts = window.GeometryAlgolia.autocompleteProductsCount;
  var nextLimit = currentLimit + window.GeometryAlgolia.autocompleteProductsStep;

  if (typeof totalProducts === "number") {
    nextLimit = Math.min(nextLimit, totalProducts);
  }

  if (nextLimit <= currentLimit) return;

  window.GeometryAlgolia.autocompleteLoadingMore = true;
  window.GeometryAlgolia.autocompleteScrollTop = scroller.scrollTop;
  window.GeometryAlgolia.autocompleteProductsLimit = nextLimit;
  window.GeometryAlgolia.refreshAutocompleteProducts();

  window.setTimeout(function () {
    window.GeometryAlgolia.autocompleteLoadingMore = false;
    window.GeometryAlgolia.loadMoreAutocompleteProductsIfNeeded();
  }, 600);
};

window.GeometryAlgolia.watchAutocompletePanelScroll = function () {
  if (window.GeometryAlgolia.autocompletePanelScrollWatcherStarted || !document.body) return;

  window.GeometryAlgolia.autocompletePanelScrollWatcherStarted = true;

  document.addEventListener(
    "scroll",
    function (event) {
      var panel = document.querySelector(".aa-Panel");
      if (!panel || !event.target || !panel.contains(event.target)) return;

      window.GeometryAlgolia.loadMoreAutocompleteProductsIfNeeded();
    },
    true,
  );

  var observer = new MutationObserver(function () {
    var scroller = window.GeometryAlgolia.getAutocompletePanelScroller();

    if (scroller && scroller.dataset.geometryAutocompleteScrollObserved !== "true") {
      scroller.dataset.geometryAutocompleteScrollObserved = "true";
      scroller.addEventListener("scroll", window.GeometryAlgolia.loadMoreAutocompleteProductsIfNeeded);
      scroller.addEventListener("wheel", window.GeometryAlgolia.loadMoreAutocompleteProductsIfNeeded, { passive: true });
      scroller.addEventListener("touchmove", window.GeometryAlgolia.loadMoreAutocompleteProductsIfNeeded, {
        passive: true,
      });
    }

    window.GeometryAlgolia.loadMoreAutocompleteProductsIfNeeded();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
};

window.GeometryAlgolia.renderInstantSearchProduct = function (item, html, components, trackSearchAttribution) {
  var image = window.GeometryAlgolia.getImage(item, 540);
  var distinct = Boolean(item && item._distinct);
  var productUrl = window.GeometryAlgolia.getProductUrl(item);

  return html`
    <a
      class="geometry-ais-product"
      href="${productUrl}"
      data-algolia-index="${item.index || ""}"
      data-algolia-position="${item.productPosition || ""}"
      data-algolia-queryid="${item.queryID || ""}"
      data-algolia-objectid="${item.objectID || ""}"
      data-handle="${item.handle || ""}"
      data-variant-id="${item.objectID || ""}"
      data-distinct="${item._distinct || ""}"
      data-product-id="${item.id || ""}"
      onClick="${function () {
        if (typeof trackSearchAttribution === "function") {
          trackSearchAttribution(item);
        } else {
          window.GeometryAlgolia.trackInstantSearchProduct(item);
        }
      }}"
    >
      <div class="geometry-ais-product__media">
        ${
          image
            ? html`
                <img
                  src="${image.src}"
                  srcset="${image.srcset}"
                  sizes="${image.sizes}"
                  alt="${item.title || "Product image"}"
                  loading="lazy"
                />
              `
            : html`<span>${(item.title || "").slice(0, 1)}</span>`
        }
      </div>
      <div class="geometry-ais-product__body">
        <div class="geometry-ais-product__title">
          ${components.Highlight({ hit: item, attribute: "title" })}
          ${
            item.product_type &&
            html`
              <span class="geometry-ais-product__title-type">
                ${components.Highlight({ hit: item, attribute: "product_type" })}
              </span>
            `
          }
          ${
            window.algoliaShopify &&
            window.algoliaShopify.helpers &&
            window.algoliaShopify.helpers.variantTitleAddition(item, distinct)
          }
        </div>
        <div class="geometry-ais-product__price">
          ${window.GeometryAlgolia.displayPriceNoDecimals(item, distinct)}
        </div>
      </div>
    </a>
  `;
};

window.GeometryAlgolia.getScrollParent = function (element) {
  var parent = element && element.parentElement;

  while (parent && parent !== document.body) {
    var styles = window.getComputedStyle(parent);
    var overflowY = styles.overflowY || styles.overflow;

    if (/(auto|scroll|overlay)/.test(overflowY) && parent.scrollHeight > parent.clientHeight) {
      return parent;
    }

    parent = parent.parentElement;
  }

  return window;
};

window.GeometryAlgolia.canLoadMoreInstantSearchHits = function (button) {
  return (
    button &&
    !button.disabled &&
    !button.classList.contains("ais-InfiniteHits-loadMore--disabled") &&
    button.dataset.geometryLoading !== "true"
  );
};

window.GeometryAlgolia.loadMoreInstantSearchHits = function (button) {
  if (!window.GeometryAlgolia.canLoadMoreInstantSearchHits(button)) return;

  button.dataset.geometryLoading = "true";
  button.click();

  window.setTimeout(function () {
    button.dataset.geometryLoading = "false";
    window.GeometryAlgolia.setupInstantSearchInfiniteObserver();
  }, 700);
};

window.GeometryAlgolia.loadMoreInstantSearchHitsIfNeeded = function () {
  var button = document.querySelector(".ais-InfiniteHits-loadMore");
  if (!window.GeometryAlgolia.canLoadMoreInstantSearchHits(button)) return;

  var threshold = 900;
  var scrollParent = window.GeometryAlgolia.getScrollParent(button);

  if (scrollParent === window) {
    if (button.getBoundingClientRect().top - window.innerHeight <= threshold) {
      window.GeometryAlgolia.loadMoreInstantSearchHits(button);
    }

    return;
  }

  if (scrollParent.scrollHeight - scrollParent.scrollTop - scrollParent.clientHeight <= threshold) {
    window.GeometryAlgolia.loadMoreInstantSearchHits(button);
  }
};

window.GeometryAlgolia.setupInstantSearchInfiniteObserver = function () {
  var button = document.querySelector(".ais-InfiniteHits-loadMore");
  if (!window.GeometryAlgolia.canLoadMoreInstantSearchHits(button)) return;

  var scrollParent = window.GeometryAlgolia.getScrollParent(button);
  var observerKey = scrollParent === window ? "window" : scrollParent.className || scrollParent.tagName;

  if (window.GeometryAlgolia.infiniteHitsObserverKey === observerKey && button.dataset.geometryObserved === "true") {
    window.GeometryAlgolia.loadMoreInstantSearchHitsIfNeeded();
    return;
  }

  if (window.GeometryAlgolia.infiniteHitsObserver) {
    window.GeometryAlgolia.infiniteHitsObserver.disconnect();
  }

  button.dataset.geometryObserved = "true";
  window.GeometryAlgolia.infiniteHitsObserverKey = observerKey;

  if ("IntersectionObserver" in window) {
    window.GeometryAlgolia.infiniteHitsObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            window.GeometryAlgolia.loadMoreInstantSearchHits(button);
          }
        });
      },
      {
        root: scrollParent === window ? null : scrollParent,
        rootMargin: "900px 0px",
      },
    );

    window.GeometryAlgolia.infiniteHitsObserver.observe(button);
  }

  window.GeometryAlgolia.loadMoreInstantSearchHitsIfNeeded();
};

window.GeometryAlgolia.watchInstantSearchInfiniteHits = function () {
  if (window.GeometryAlgolia.infiniteHitsWatcherStarted || !document.body) return;

  window.GeometryAlgolia.infiniteHitsWatcherStarted = true;
  window.GeometryAlgolia.setupInstantSearchInfiniteObserver();

  var observer = new MutationObserver(function () {
    window.GeometryAlgolia.setupInstantSearchInfiniteObserver();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  document.addEventListener("scroll", window.GeometryAlgolia.loadMoreInstantSearchHitsIfNeeded, true);
  window.addEventListener("resize", window.GeometryAlgolia.loadMoreInstantSearchHitsIfNeeded);
};

window.GeometryAlgolia.registerHooks = function () {
  if (window.GeometryAlgolia.hooksRegistered) return;
  if (!window.algoliaShopify || !window.algoliaShopify.hooks) return;

  window.GeometryAlgolia.hooksRegistered = true;
  var hooks = window.algoliaShopify.hooks;

  hooks.registerHook("beforeAutocompleteOptions", function (options) {
    var originalOnStateChange = options.onStateChange;

    options.placeholder = "Search Geometry";
    options.openOnFocus = true;
    options.onStateChange = function (params) {
      var state = params && params.state ? params.state : {};
      var query = state.query || "";

      window.GeometryAlgolia.autocompleteRefresh = params && params.refresh;
      window.GeometryAlgolia.watchAutocompletePanelScroll();

      if (query !== window.GeometryAlgolia.autocompleteQuery) {
        window.GeometryAlgolia.autocompleteQuery = query;
        window.GeometryAlgolia.resetAutocompleteProductsLimit();
      }

      if (state.context && typeof state.context.nbProducts === "number") {
        window.GeometryAlgolia.autocompleteProductsCount = state.context.nbProducts;
      }

      window.setTimeout(window.GeometryAlgolia.loadMoreAutocompleteProductsIfNeeded, 0);

      if (typeof originalOnStateChange === "function") {
        return originalOnStateChange.apply(this, arguments);
      }
    };

    return options;
  });

  hooks.registerHook("beforeAutocompleteConfigurationOptions", function (config, context) {
    context = context || {};

    if (context.pluginName !== "products" && context.sourceId !== "products") return config;
    if (!Array.isArray(config.queries)) return config;

    config.queries = config.queries.map(function (query) {
      return Object.assign({}, query, {
        params: Object.assign({}, query.params, {
          hitsPerPage: window.GeometryAlgolia.autocompleteProductsLimit,
          clickAnalytics: true,
        }),
      });
    });

    return config;
  });

  hooks.registerHook("beforeAutocompletePluginOptions", function (options, context) {
    if (!options.searchParameters) {
      options.searchParameters = {};
    }

    if (context.pluginName === "products") {
      options.searchParameters.hitsPerPage = window.GeometryAlgolia.autocompleteProductsStep;
      options.searchParameters.clickAnalytics = true;
    } else if (
      context.pluginName === "collections" ||
      context.pluginName === "articles" ||
      context.pluginName === "pages"
    ) {
      options.searchParameters.hitsPerPage = 3;
    }

    return options;
  });

  hooks.registerHook(
    "beforeAutocompleteMainTemplate",
    function (_defaultTemplate, templateOptions, elements) {
      var html = templateOptions.html;

      return html`
        <div class="aa-PanelLayout aa-Panel--scrollable geometry-aa-panel">
          <div class="geometry-aa-panel__products geometry-aa-panel__products--only">
            ${elements.products}
          </div>
        </div>
      `;
    },
  );

  hooks.registerHook(
    "beforeAutocompleteProductTemplate",
    function (_defaultTemplate, templateOptions, distinct, itemLink, trackSearchAttribution) {
      var html = templateOptions.html;
      var item = templateOptions.item;
      var components = templateOptions.components;
      var image = window.GeometryAlgolia.getImage(item, 360);

      return html`
        <a
          href="${itemLink}"
          class="aa-ItemLink aa-ProductItem geometry-aa-product"
          onClick="${function () {
            trackSearchAttribution(item);
          }}"
        >
          <div class="aa-ItemContent geometry-aa-product__content">
            <div class="aa-ItemPicture aa-ItemPicture--loaded geometry-aa-product__picture">
              ${
                image
                  ? html`
                      <img
                        src="${image.src}"
                        srcset="${image.srcset}"
                        sizes="${image.sizes}"
                        alt="${item.title || "Product image"}"
                        loading="lazy"
                      />
                    `
                  : html`<span>${(item.title || "").slice(0, 1)}</span>`
              }
            </div>
            <div class="aa-ItemContentBody geometry-aa-product__body">
              <div class="aa-ItemContentTitle geometry-aa-product__title">
                ${components.Highlight({ hit: item, attribute: "title" })}
                ${
                  item.product_type &&
                  html`
                    <span class="geometry-aa-product__title-type">
                      ${components.Highlight({ hit: item, attribute: "product_type" })}
                    </span>
                  `
                }
                <span class="algolia-variant">
                  ${algoliaShopify.helpers.variantTitleAddition(item, distinct)}
                </span>
              </div>
              <div class="aa-ItemContentPrice geometry-aa-product__price">
                ${window.GeometryAlgolia.displayPriceNoDecimals(item, distinct)}
              </div>
            </div>
          </div>
        </a>
      `;
    },
  );

  hooks.registerHook("beforeAutocompleteNoResultsTemplate", function (_defaultTemplate, templateOptions) {
    var html = templateOptions.html;
    var state = templateOptions.state || {};
    var query = encodeURIComponent(state.query || "");

    return html`
      <div class="aa-PanelLayout aa-Panel--scrollable geometry-aa-panel geometry-aa-no-results">
        <div class="geometry-aa-no-results__copy">
          <p class="geometry-aa-no-results__eyebrow">No matches found</p>
          <h2 class="geometry-aa-no-results__title">No results for "${state.query || ""}"</h2>
          <p class="geometry-aa-no-results__text">
            Try one of our most-shopped categories, or browse everything.
          </p>
        </div>

        <div class="geometry-aa-no-results__links" aria-label="Shop by category">
          ${window.GeometryAlgolia.categoryLinks.map(function (link) {
            return html`
              <a class="geometry-aa-no-results__link" href="${window.GeometryAlgolia.getThemeRoute(link.path)}">
                <span class="geometry-aa-no-results__thumb">
                  <img
                    src="${window.GeometryAlgolia.getShopFileImage(link.image, 240)}"
                    alt=""
                    loading="lazy"
                    aria-hidden="true"
                  />
                </span>
                <span>${link.label}</span>
              </a>
            `;
          })}
        </div>

        <a
          class="geometry-aa-no-results__all"
          href="${window.GeometryAlgolia.getThemeRoute("search")}?q=${query}"
        >
          See all products
        </a>
      </div>
    `;
  });

  hooks.registerHook(
    "beforeAutocompleteCollectionsTemplate",
    function (_defaultTemplate, templateOptions, itemLink) {
      var html = templateOptions.html;
      var item = templateOptions.item;
      var components = templateOptions.components;
      var collectionImage = item.image ? window.GeometryAlgolia.getImage(item, 160) : null;
      var productCountLabel = item.products_count === 1 ? "product" : "products";

      return html`
        <a href="${itemLink}" class="aa-ItemLink geometry-aa-collection">
          <div class="aa-ItemContent geometry-aa-collection__content">
            <div class="geometry-aa-collection__image">
              ${
                collectionImage
                  ? html`
                      <img
                        src="${collectionImage.src}"
                        srcset="${collectionImage.srcset}"
                        sizes="${collectionImage.sizes}"
                        alt="${item.title || "Collection image"}"
                        loading="lazy"
                      />
                    `
                  : html`<span>${(item.title || "").slice(0, 1)}</span>`
              }
            </div>
            <div class="aa-ItemContentBody geometry-aa-collection__body">
              <div class="aa-ItemContentTitle geometry-aa-collection__title">
                ${components.Highlight({ hit: item, attribute: "title" })}
              </div>
              ${
                item.products_count &&
                html`
                  <div class="geometry-aa-collection__count">
                    ${algoliaShopify.helpers.formatNumber(item.products_count)} ${productCountLabel}
                  </div>
                `
              }
            </div>
          </div>
        </a>
      `;
    },
  );

  hooks.registerHook("beforeAutocompleteFooterTemplate", function (_defaultTemplate, templateOptions) {
    var html = templateOptions.html;
    var state = templateOptions.state;
    var query = encodeURIComponent(state.query || "");

    return html`
      <div class="aa-footer geometry-aa-footer">
        <a class="aa-SeeAllBtn geometry-aa-see-all" href="${window.Shopify.routes.root}search?q=${query}">
          See all results
          (${algoliaShopify.helpers.formatNumber(state.context.nbProducts || 0)})
        </a>
      </div>
    `;
  });

  hooks.registerHook("beforeInstantSearchConfigurationOptions", function (options) {
    options.stalledSearchDelay = 300;
    return options;
  });

  hooks.registerHook("beforeInstantSearchOptions", function (options) {
    options.hitsPerPage = 12;
    return options;
  });

  hooks.registerHook("beforeInstantSearchProductTemplate", function (_defaultTemplate, hit, html, components, trackSearchAttribution) {
    return window.GeometryAlgolia.renderInstantSearchProduct(hit, html, components, trackSearchAttribution);
  });

  var removeDefaultHitsAndPagination = function (defaultWidgets) {
    if (!Array.isArray(defaultWidgets)) return [];

    return defaultWidgets.filter(function (widget) {
      var widgetType = widget && (widget.$$widgetType || widget.widgetType);
      return widgetType === "ais.hits" || widgetType === "ais.pagination";
    });
  };

  var addInfiniteHitsWidget = function () {
    var infiniteHits = window.GeometryAlgolia.getInfiniteHitsWidget();
    if (!infiniteHits || window.GeometryAlgolia.instantSearchInfiniteHitsAdded) return [];

    window.GeometryAlgolia.instantSearchInfiniteHitsAdded = true;

    window.GeometryAlgolia.watchInstantSearchInfiniteHits();

    return [
      infiniteHits({
        container: ".ais-hits-container",
        templates: {
          item: function (item, helpers) {
            return window.GeometryAlgolia.renderInstantSearchProduct(item, helpers.html, helpers.components);
          },
          showMoreText: function (_data, helpers) {
            return helpers.html`<span>Load more products</span>`;
          },
        },
      }),
    ];
  };

  hooks.registerHook("afterInstantSearchStartRemoveDefaultWidgets", removeDefaultHitsAndPagination);
  hooks.registerHook("beforeInstantSearchStartAddWidgets", addInfiniteHitsWidget);
  hooks.registerHook("afterISStartRemoveDefaultWidget", removeDefaultHitsAndPagination);
  hooks.registerHook("beforeISStartAddWidgetArray", addInfiniteHitsWidget);

  hooks.registerHook("beforeInstantSearchFacetParamsOptions", function (params, facet) {
    if (facet.type === "slider") {
      return Object.assign({}, params, {
        pips: false,
        tooltips: true,
      });
    }

    if (facet.name === "tags" || facet.title === "Tags") {
      return Object.assign({}, params, {
        limit: 12,
        showMore: true,
        showMoreLimit: 40,
        searchable: true,
      });
    }

    if (facet.type === "conjunctive" || facet.type === "disjunctive") {
      return Object.assign({}, params, {
        limit: 10,
        showMore: true,
        showMoreLimit: 32,
      });
    }

    return params;
  });
};

document.addEventListener("algolia.hooks.initialize", window.GeometryAlgolia.registerHooks);
document.addEventListener("algolia.instantSearch.afterRender", window.GeometryAlgolia.setupInstantSearchInfiniteObserver);
window.GeometryAlgolia.registerHooks();
